module.exports = __webpack_public_path__ + "static/media/5 menuItem.3c6df706.png";